import { render, staticRenderFns } from "./NewTrainer.vue?vue&type=template&id=6d19f1fe&scoped=true&"
import script from "./NewTrainer.vue?vue&type=script&lang=js&"
export * from "./NewTrainer.vue?vue&type=script&lang=js&"
import style0 from "./NewTrainer.vue?vue&type=style&index=0&id=6d19f1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19f1fe",
  null
  
)

export default component.exports